import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import { getFloorplanBackgroundImage, getOffsetRect } from '../helpers';
import * as FloorplanActions from './FloorplanActions';
import FloorplanContainer from './FloorplanContainer';
import './Style';

class FloorplanWrapperContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            windowWidth: window.innerWidth,
            error: null,
            errorInfo: null
        }

      this.openMobileFloorplan = this.openMobileFloorplan.bind(this);
      this.windowOnResize = this.windowOnResize.bind(this);
    }

    componentDidMount = () => {
        window.addEventListener('resize', this.windowOnResize, false);
        window.addEventListener('message', (e) => {
            console.log('post-m-story', e.data);
            const { presentation } = e.data
            if (presentation) {
                this.setState({
                    presentation: true
                })
            }
        })
    }

    componentWillUnmount = () => {
      window.removeEventListener('resize', this.windowOnResize, false);
    }

    windowOnResize() {
        this.setState({
            windowWidth: window.innerWidth
        });
    }

    openMobileFloorplan() {
        this.props.floorplanActions.navigateToFloorplan({
            id: 'floorplan',
            top: getOffsetRect(this.floorplan).top
        });
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo
        }, () => {
            console.error(error, errorInfo);
        })
    }

    render() {
        const { floorplanImagesPath, floorplanStages } = this.props;
        const { windowWidth, error } = this.state;

        if (!floorplanStages.length || error) {
            return null;
        }

        const floorplanBackgroundImage = getFloorplanBackgroundImage(
            floorplanImagesPath, floorplanStages
        );

        const floorplanImageBlock = floorplanBackgroundImage
            ? (
                <div className="overlay-image-wrapper">
                    <div className="overlay-image">
                    </div>
                    <img src={floorplanBackgroundImage}/>
                </div>
            )
            : null;

        const floorplanOverlay = (
            <div className="floorplan-overlay">
                <div className="overlay-content">
                    <div className="overlay-controls">
                        <i
                            className="fa fa-play-circle"
                            onClick={this.openMobileFloorplan}>
                        </i>
                        <p>explore floor plan</p>
                    </div>
                    {floorplanImageBlock}
                </div>
            </div>
        );

        return (
            <div
                id='floorplan'
                className="floorplan-wrapper"
                style={this.state.presentation ? { height: document.body.offsetWidth * (3 / 4) } : {}}
                ref={floorplan => this.floorplan = floorplan}>
                <h2 className="section-header">Interactive Floor plan</h2>
                {windowWidth < 1200
                    ? floorplanOverlay
                    : <FloorplanContainer />}
            </div>
        )
    }
}

FloorplanWrapperContainer.propTypes = {
    floorplanImagesPath: PropTypes.string.isRequired,
    floorplanStages: PropTypes.array
}

const mapStateToProps = (state) => ({
    floorplanImagesPath: state.floorplan.imagesPath,
    floorplanStages: state.floorplan.stages
});

const mapDispatchToProps = (dispatch) => ({
    floorplanActions: bindActionCreators(FloorplanActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(FloorplanWrapperContainer);